module.exports = __webpack_public_path__ + "static/media/strength.8dd86005.svg";